module.exports = __webpack_public_path__ + "static/media/post-10.5bfc09e7.jpg";